export default "__VITE_ASSET__Dv7hXRc4__"